module.exports = __webpack_public_path__ + "img/menu.87916c5d.svg";